<template>
  <div>
    <template v-if="lightOrderStep === 0">
      <vz-order-direction-block title="" hide-waiting />
      <vz-individual-order-special-requirements-block simple />
    </template>

    <vz-individual-cargo-block v-if="lightOrderStep === 1" title="" simple />

    <template v-if="lightOrderStep === 2">
      <vz-individual-order-payer-block hide-segregate hide-project />
      <vz-order-members-block />
    </template>

    <template v-if="lightOrderStep === 3">
      <div class="vz-order-view-blocks">
        <vz-direction-view :order="orderForm" />
        <vz-direction-view :order="orderForm" direction-to />
      </div>
      <vz-order-view-cargo-block :order="orderForm" />
      <vz-order-view-customer-block :order="orderForm" />
    </template>
    <vz-light-order-step-footer @send-form="emit('send-form')" />
  </div>
</template>

<script setup lang="ts">
import VzOrderDirectionBlock
  from '~/components/personal/order/direction/vz-order-direction-block.vue';
import VzIndividualOrderSpecialRequirementsBlock
  from '~/components/personal/order/special-requirements/vz-individual-order-special-requirements-block.vue';
import VzIndividualOrderPayerBlock from '~/components/personal/order/payer/vz-individual-order-payer-block.vue';
import VzIndividualCargoBlock from '~/components/personal/order/cargo/vz-individual-cargo-block.vue';
import VzOrderMembersBlock from '~/components/personal/order/members/vz-order-members-block.vue';
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import VzLightOrderStepFooter from '~/components/personal/order/light-order/vz-light-order-step-footer.vue';
import VzDirectionView from '~/components/personal/order/vz-order-view/direction/vz-direction-view.vue';
import VzOrderViewCargoBlock from '~/components/personal/order/vz-order-view/vz-order-view-cargo-block.vue';
import VzOrderViewCustomerBlock from '~/components/personal/order/vz-order-view/vz-order-view-customer-block.vue';

const emit = defineEmits(['send-form'])

const { lightOrderStep, orderForm } = storeToRefs(useOrderStore())
</script>
